import React, { Component } from 'react';
import './questions-list.scss';
import { Constants, ImageConstants } from '../../../../constants/constants';
import CommonUtils from '../../../../utility/common-utilities'
import CwContentViewer from '../../../common/cw-content-viewer/cw-content-viewer'
import CwQuestionViewer from '../../../common/cw-question-viewer/cw-question-viewer'
import { getImageSource } from '../../../../utility/image-source';

class QuestionList extends Component {

    state = {
        showOptions: true,
        questions: []
    }

    componentDidMount() {
        this.setState({
            questions: this.props.questions
        })
    }



    onClickBack = () => {
        this.props.back()
    }
    reRender = () => {
        this.setState({ reRender: true })
    }

    onSelectMandatoryAttachment = (val, qnIndex) => {
        const { questions }= this.state
        questions[qnIndex].mandatoryAttachments = {
            video: false,
            audio: false,
            image: val
        }
        this.setState({
            questions
        }, _ => {
            this.props.saveQuestions(questions)
        })
    }

    getTotalMarks = _ => {
        const {questions} = this.state
        let totalMarks = 0
        if(questions?.length) {
            questions.map(q => {
                if(q.content?.mark) totalMarks += parseInt(q.content?.mark)
            })
        }
        return totalMarks
    }

    getEstimatedTime = _ => {
        const {questions} = this.state
        let duration = 0
        if(questions?.length) {
            questions.map(q => {
                if(q.content?.complexity === "Low") {
                    duration += 1
                } else if(q.content?.complexity === "Medium") {
                    duration += 3
                } else if(q.content?.complexity === "High") {
                    duration += 5
                } 
            })
        }
        return duration
    }

    toggleQuestionOptions = _ => {
        this.setState({
            openQuestionOptions: !this.state.openQuestionOptions
        })
    }

    renderList = () => {
        return (
            <div>
                <div className='question-details'>
                    <span>Total Qs. Selected: <strong>{this.state.questions?.length || 0}</strong></span>
                    <span>Estimated Time: <strong>{this.props.payload?.questionSource !== "questionbank" ? 
                                            this.props.payload?.duration || 15 : 
                                            this.getEstimatedTime()} mins</strong></span>
                    <span>Total Marks: <strong>{this.getTotalMarks()}</strong></span>
                    <div className='add-questions-container'>
                        <button
                            className='cw-btn-md cw-btn-primary add-questions ml-4'
                            onClick={this.toggleQuestionOptions}
                        >
                            Add Questions
                        </button>
                        {this.state.openQuestionOptions && (
                            <div className='add-question-options'>
                                <div className='text-right'>
                                    <img className='close-icn' onClick={this.toggleQuestionOptions} src={getImageSource(ImageConstants.CROSS)} />
                                </div>
                                <div
                                    className='option cursor-pointer'
                                    onClick={_ =>
                                        this.props.pickFromBank(1)
                                    }
                                >Pick from My Question Bank</div>
                                <div className='option cursor-pointer' 
                                    onClick={_ => 
                                        {
                                            this.setState({openQuestionOptions: false}, _ => {
                                                this.props.openAddQuestion()
                                            })
                                        }
                                }>Create a new Question</div>
                            </div>
                            )
                        }
                    </div>
                </div>
                <div className='review-list'>
                    {
                        this.state.questions?.length ?
                            this.state.questions.map((question, qnIndex) => (
                                <div className='review-question' key={question.id || question._id}>
                                    <div className='review-left'>
                                        <div className="elo-index">{`Question ${qnIndex + 1}`}</div>
                                        <div className="mt-2">
                                            <div
                                                className={`name checkbox-alignment ${question.mandatoryAttachments?.image ? "active": ""}`}
                                                onClick={() =>
                                                this.onSelectMandatoryAttachment(
                                                    !question.mandatoryAttachments?.image,
                                                    qnIndex
                                                )
                                                }
                                            >
                                                <div className='custom-checkbox'>
                                                {question.mandatoryAttachments?.image ? (
                                                    <div className='tick-mark'></div>
                                                ) : (
                                                    ''
                                                )}
                                                </div>
                                                <span className='chekbox-title'>
                                                    <img src={getImageSource(ImageConstants.CAMERA)} />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='review-right'>
                                        <div className='qn-title with-delete'>
                                            <CwContentViewer content={question?.content?.title} />
                                            <div className='question-right'>
                                                {question.content?.complexity && <div className='icons'><img src={getImageSource(ImageConstants["SKILL_" + question.content?.complexity?.toUpperCase() + "_ICN"])} /> {question.content?.complexity?.substr(0, 1)}</div>}
                                                {question.content?.mark && <div className='icons'><img src={getImageSource(ImageConstants.MARK_ICN)} /> {question.content?.mark}</div>}
                                                <div className='icons'><img onClick={_ => this.props.onDeleteQuestion(qnIndex)} src={getImageSource(ImageConstants.DELETE_RED)} className="delete-icn cursor-pointer"></img></div>
                                            </div>
                                        </div>
                                        {
                                            question.content?.images?.length ? question.content?.images.map((image, imageIndex) =>
                                                <img className='image-container mb-4 mr-3' src={image.imageUrl} alt="" />
                                            )
                                                :
                                                ""

                                        }
                                        {this.state.showOptions ? <CwQuestionViewer type={question.content?.type} question={question} /> : ""}
                                    </div>
                                </div>
                            ))
                            : ""

                    }
                </div>
            </div>
        )
    }

    render() {
        return (
            <div>
                {this.renderList()}
            </div >
        );
    }
}

export default QuestionList;